/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import {scrollToAnchor} from "../../theme/commonStyle";

const commonJobsStyles ={
  headline: {
    textAlign: "center",
    paddingBottom: "2rem",
  },
  container: {
    paddingBottom: "3.5rem",
  },
  scrollToAnchor,
};

export default commonJobsStyles;
